export const types = <const>{
	mutations: {
		ODLOZENA_CINNOST_PRACOVNIK_SELECT_MAPPER: 'ODLOZENA_CINNOST_PRACOVNIK_SELECT_MAPPER',
	},
};
